import { http } from '@/utils/http.js';
import { teamPath } from '@/utils/paths.js';

export const ApplicationsApi = {
  getApps(query) {
    return http.get(`${teamPath()}/applications`, { params: query }).then((response) => response.data);
  },

  getApp(id) {
    return http.get(`${teamPath()}/applications/${id}`).then((response) => response.data.data);
  },

  createApp(data) {
    return http.post(`${teamPath()}/applications`, data).then((response) => response.data.data);
  },

  updateApp(id, data) {
    return http.patch(`${teamPath()}/applications/${id}`, data).then((response) => response.data.data);
  },

  deleteApp(id) {
    return http.delete(`${teamPath()}/applications/${id}`).then((response) => response.data);
  },
};
